const duplicateAssociateEmail = params => {
  const { firstName } = params;
  return `${firstName} has already been invited or already has an account`;
};

const dupliateUserEmail = params => {
  const { firstName } = params;
  return `${firstName} has already been invited or already has an account`;
};

const errorMapper = {
  "duplicate-associate-email": duplicateAssociateEmail,
  "duplicate-user-email": dupliateUserEmail
};

module.exports = { errorMapper };
